// extracted by mini-css-extract-plugin
export default {"section":"blogs_section__PQe4S","container":"blogs_container__ISoGX","container_description":"blogs_container_description__7bcuB","button":"blogs_button__3Y7Cg"};